import { createStyles, Stack } from "@mantine/core";
import { RpiLabelText, RpiTitle } from "@rpi/openapi-core";
import { DefaultComponents } from "@aws-amplify/ui-react/dist/types/components/Authenticator/hooks/useCustomComponents/defaultComponents";
import { Translations } from "@aws-amplify/ui-components";

import { Authenticator } from "@aws-amplify/ui-react";
import { I18n } from "aws-amplify";

const useUpdateTempPwStyles = createStyles((theme) => ({
  authHeader: {
    alignItems: "center",
    gap: theme.spacing.md,
    marginBottom: theme.spacing.md,
  },
}));

export const forceNewPasswordComponent: DefaultComponents["ForceNewPassword"] = {
  FormFields() {
    const { classes } = useUpdateTempPwStyles();

    return (
      <Stack>
        <Stack className={classes.authHeader}>
          <img src="/logo.svg" width={94} height={94} />
          <RpiTitle>{"Reset Password"}</RpiTitle>
          <RpiLabelText>{"Please set your new password below."}</RpiLabelText>
        </Stack>
        <Authenticator.ForceNewPassword.FormFields />
      </Stack>
    );
  },
};

I18n.putVocabulariesForLanguage("en", {
  [Translations.CHANGE_PASSWORD]: "Save New Password",
  Changing: "Saving new password...",
});
